export default "__VITE_ASSET__5e4503dc__"